<template>
  <div>
    <label for="tipo-viagem" class="required">Tipo de Viagem:</label>
    <select v-model="selected" @change="enviarEmit" id="tipo-viagem">
      <option v-for="t in tiposViagem" :key="t.id" :value="t.viagem">
        {{ t.viagem }}
      </option>
    </select>
  </div>
</template>
  
<script>
export default {
  name: 'TipoViagem',
  emits: ['tipo-viagem-selecionado'],
 
  data() {
    return {
      tiposViagem: [],
      selected: ''
    };
  },

  methods: {

    async getTiposViagem() {
      try {
        const path = '/tipo_viagem';
        const response = await this.$axios.get(path);
        this.tiposViagem = response.data;
      } catch (error) {
        if (error.response) {
          console.error('(buscando tipos de viagem) Resposta do servidor com status:', error.response.status);
        } else {
          console.error('(buscando tipos de viagem) Erro sem resposta do servidor:', error.message);
        }
      }
    },

    enviarEmit() {
      this.$emit('tipo-viagem-selecionado', this.selected);
    }
  },

  mounted() {
      this.getTiposViagem();
  },

};
</script>
  
<style scoped>
/* Adicione estilos específicos para o componente aqui, se necessário */
</style>